import { Tag } from './Tag';
export class TagFileModel {
	DocumentId: string;
	Name: string;
	Description?: string;
}

export class UpdateInterestsModel
{
	DocumentId: string;
	InterestIds: number[] =[];
}

export interface LearningCourse {
  CourseName: string;
  CourseImageId?: string;      
  Description?: string;
  LearningOutcomes?: string;
  TargetAudience?: string;
  Speakers?: string;
  CoursePathId: number;
  Tags?: string;
}
export interface CoursePath {
  Id?: number;
  Name?: string;
  Description?: string;
  PathOrder: number;
  CreatedByUserId?: string;
  Published?: boolean;
  DateCreatedUtc?: string;
  DateUpdatedUtc?: string;
  CourseId?: string;
  CoverId?: string;
}



export class DescribeFileModel {
	DocumentId: string;
	Description?: string;
	Pages?: number;
	Orientation?: string;
}

export class UploadLinkModel {
	DirectoryId: string;
	Link: string;
}

export class TagQuestionModel {
	QuestionId: number;
	Name: string;
	Description?: string;
}

export class RenameFileModel {
	DocumentId: string;
	Name: string;
}

export class RenameDirectoryModel {
	Id: string;
	Name: string;
}

export class UpdateDirectoryMetaModel {
	public Id: number;
	public Color: string;
	public LogoId: number;
	public Description: string;
	public IconId: number;
	public Heading: string;
	public Structured: BarProp;
}

export class MoveDirectoryModel {
	Id: string;
	ParentId: string;
}

export class ReorderDirectoryFilesModel {
	public DirectoryId: number;
	public Files: number[];
}

export class AddObjectiveModel {
	public DirectoryId: number;
	public Description: string;
}


export class AddDocumentAuthor {
	public DocumentId: number;
	public Name: string;
	public Description: string;
	public Institute: string;
	public PictureId: string;
	public InstitutePictureId: string;
	public VideoDuration: string;
	public LearningCourseId: number;
	public AttachmentFileId :string;
}


export class UpdatePlansModel {
	public DocumentId: string;
	public PlanIds: number[];
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/TagFileModel.ts